export default {
  getDistribuicaoTableHeaders(state) {
    return state.distribuicaoTableHeaders;
  },
  getDistribuicaoTableItems(state) {
    return state.distribuicaoTableItems;
  },
  getFiltros(state) {
    return state.filtros;
  },
  getMarcas(state) {
    return state.marcas;
  },
};
